module.exports = __webpack_public_path__ + "img/triangle1red.5176b594.png";